import type { ReactNode } from "react";
import { CheckIcon } from "./Icons";

interface CardProps {
  /** Step number in the flashing sequence; omit for non-sequential panels. */
  step?: number;
  /** Renders the step marker as complete. */
  done?: boolean;
  title: string;
  hint?: string;
  actions?: ReactNode;
  children: ReactNode;
  flush?: boolean;
}

export function Card({ step, done, title, hint, actions, children, flush }: CardProps) {
  return (
    <section className="card">
      <header className="card__header">
        {step !== undefined && (
          <span className={`card__step${done ? " card__step--done" : ""}`}>
            {done ? <CheckIcon size={13} /> : step}
          </span>
        )}
        <div className="card__titles">
          <h2 className="card__title">{title}</h2>
          {hint && <p className="card__hint">{hint}</p>}
        </div>
        {actions}
      </header>
      <div className={`card__body${flush ? " card__body--flush" : ""}`}>{children}</div>
    </section>
  );
}
